import { createContext, useContext, useState, ReactNode } from "react";
import {TEntityTypes, TFeedbackDetails} from "../../services/feedbackService";

interface FeedbackContextProps {
    showFeedbackForm: boolean;
    reaction: "positive" | "negative" | null;
    feedbackPlace: string;
    openFeedback: (
      reaction?: "positive" | "negative" | null,
      feedbackPlace?: string,
      feedbackDetails?: TFeedbackDetails | null,
      feedbackId?: string,
      entityId?: string | null,
      entityType?: TEntityTypes,
    ) => void;
    closeFeedback: () => void;
    feedbackDetail?: TFeedbackDetails | null,
    entityId?: string | null,
    entityType?: TEntityTypes,
    feedbackId?: string,
    setFeedbackDetail?: (props : TFeedbackDetails | null) => void;
}

const FeedbackContext = createContext<FeedbackContextProps | undefined>(undefined);

export const FeedbackProvider = ({ children }: { children: ReactNode }) => {
    const [showFeedbackForm, setShowFeedbackForm] = useState(false);
    const [reaction, setReaction] = useState<"positive" | "negative" | null>(null);
    const [feedbackPlace, setFeedbackPlace] = useState<string>('');
    const [feedbackDetail, setFeedbackDetail] = useState<TFeedbackDetails | null>(null);
    const [_entityId, setEntityId] = useState<string>();
    const [_entityType, setEntityType] = useState<TEntityTypes>();
    const [_feedbackId, setFeedbackId] = useState<string>();

    const openFeedback = (
      reaction: "positive" | "negative" | null = null,
      feedbackPlace: string = 'Anasysis',
      feedbackDetails?: TFeedbackDetails | null,
      feedbackId?: string,
      entityId?: string | null,
      entityType?: TEntityTypes
    ) => {
      if (reaction) {
        setReaction(reaction);
        setFeedbackPlace(feedbackPlace);
        if (feedbackDetails) {
          setFeedbackDetail(feedbackDetails);
        } else {
          setFeedbackDetail(null);
        }
        setFeedbackId(feedbackId);
        if(!feedbackDetails && entityId && entityType) {
          setEntityId(entityId);
          setEntityType(entityType);
        }
      } else {
        setReaction(null);
        setFeedbackPlace(feedbackPlace);
        setFeedbackDetail(null);
        setFeedbackId('');
        setEntityId('');
      }
      setTimeout(() => {
        setShowFeedbackForm(true);
      }, 100);
    };

    const closeFeedback = () => {
      setTimeout(() => {
        setShowFeedbackForm(false);
      }, 100);
    };

    return (
        <FeedbackContext.Provider value={{
          showFeedbackForm,
          reaction,
          feedbackPlace,
          openFeedback,
          closeFeedback,
          feedbackDetail,
          feedbackId: _feedbackId,
          entityId: _entityId,
          entityType: _entityType,
          setFeedbackDetail: setFeedbackDetail,
        }}>
            {children}
        </FeedbackContext.Provider>
    );
};

export const useFeedback = () => {
    const context = useContext(FeedbackContext);
    if (!context) {
        throw new Error("useFeedback must be used within a FeedbackProvider");
    }
    return context;
};
